import { Checkbox, Modal, Typography } from 'antd'
import { FC, useState } from 'react'
import formatNumber from '../../../../../helpers/formatters/format-any-number'
import useErrorModal from '../../../../../hooks/api/use-error-modal'
import { useGetMachinesQuery } from '../../../../../store/api/machines-api'
import { useDistributeRewindJobMutation } from '../../../../../store/api/rewind-jobs-api'
import { rewindQueueEntriesApi } from '../../../../../store/api/rewind-queue-entries-api'
import { useAppDispatch } from '../../../../../store/store'
import RewindQueueEntry from '../../../../../types/api/rewind-queue-entry'
import { DocumentId } from '../../../../../types/strapi/strapi'
import { rewinderMachinesQuery } from '../../constants/query-params'
import { getRewindJobCopies } from '../../helpers/get-rewind-job-copies'

interface SplitToMachinesModalProps {
    rewindQueueEntry: RewindQueueEntry
    open: boolean
    onClose: () => void
}

const SplitToMachinesModal: FC<SplitToMachinesModalProps> = ({
    rewindQueueEntry,
    open,
    onClose,
}) => {
    const dispatch = useAppDispatch()
    const [selected, setSelected] = useState<DocumentId[]>([])
    const { data } = useGetMachinesQuery(rewinderMachinesQuery)
    const [distributeRewindJob, distributeRewindJobState] = useDistributeRewindJobMutation()
    const machines = [...(data?.data || [])]
        .filter(machine => machine.documentId !== rewindQueueEntry.machine?.documentId)
        .sort((a, b) => a.name.localeCompare(b.name))
    const copies = getRewindJobCopies(rewindQueueEntry.rewind_job)

    useErrorModal(distributeRewindJobState, 'Ошибка деления задания перемотки')

    const onOk = async () => {
        if (!rewindQueueEntry.rewind_job) return

        const result = await distributeRewindJob({
            docId: rewindQueueEntry.rewind_job.documentId,
            machines: selected,
        })

        if ('data' in result) {
            dispatch(rewindQueueEntriesApi.util.invalidateTags(['RewindQueueEntries']))
            setSelected([])
            onClose()
        }
    }

    return (
        <Modal
            title='Разделить на станки'
            open={open}
            onOk={onOk}
            okText='Разделить'
            okButtonProps={{ disabled: selected.length === 0 }}
            confirmLoading={distributeRewindJobState.isLoading}
            onCancel={onClose}
        >
            <Typography.Paragraph>
                Тираж части {formatNumber(copies)} поровну разделится между станком{' '}
                {rewindQueueEntry.machine?.name} и выбранными станками.
            </Typography.Paragraph>
            <Checkbox.Group
                value={selected}
                onChange={values => setSelected(values as DocumentId[])}
                options={machines.map(machine => ({
                    value: machine.documentId,
                    label: machine.name,
                }))}
            />
        </Modal>
    )
}

export default SplitToMachinesModal
